import { render } from "./SubmissionEmail.vue?vue&type=template&id=5f5bebe4"
import script from "./SubmissionEmail.vue?vue&type=script&lang=js"
export * from "./SubmissionEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__